// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"99":"2e10d4c02bbcd34d0114","833":"d85f4cd9afa0c7961d9f","926":"80f1bae5b34c0ed5ca2a"}[chunkId] + ".chunk.js";
};